const SDK_LIST = {
  CASHFREE: 'cashfree-sdk'
};

export default SDK_LIST;
